export default [
  {
    path: "banner",
    label: "Home",
    offset: -10000,
  },
  {
    path: "features",
    label: "How we Work",
    offset: -750,
  },
  // {
  //   path: "services",
  //   label: "Services",
  //   offset: -40,
  // },
  {
    path: "clients",
    label: "Clients",
    offset: -70,
  },
  {
    path: "blog",
    label: "Blogs",
    offset: -60,
  },
];
